<template>
    <div class="mainBox">
		<div class="d_title">
            <el-page-header @back="goBack" content="新闻管理"></el-page-header>
		</div>
		<el-form ref="updateForm" :model="updateForm" :rules='formItemRules' label-width="90px" size="medium">
            <el-form-item prop='language' label='语言'>
                <el-select v-model="updateForm.language" placeholder="请选择语言" clearable>
                    <el-option label="中文" value="cn"></el-option>
                    <el-option label="英文" value="en"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop='title' label='标题'>
                <el-input v-model="updateForm.title" placeholder='请输入标题' clearable></el-input>
            </el-form-item>
            <el-form-item prop='brief' label="摘要">
                <el-input type="textarea" autosize v-model="updateForm.brief"></el-input>
            </el-form-item>
            <el-form-item prop='cover' label="封面">
                <el-upload
                    class="cover-uploader"
                    action="https://ecogreenweb.icangjiang.com/upload/upyun"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess">
                    <img v-if="updateForm.cover" :src="updateForm.cover" class="cover-img">
                    <i v-else class="el-icon-plus cover-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <el-form-item prop='content' label='内容' class="quill-form-item">
                <quill-editor v-model="updateForm.content"></quill-editor>
            </el-form-item>
            <el-form-item prop='seo_title' label='SEO标题'>
                <el-input v-model="updateForm.seo_title" placeholder='不写就系统默认' clearable></el-input>
            </el-form-item>
            <el-form-item prop='seo_keyword' label='SEO关键字'>
                <el-input type="textarea" :autosize="{ minRows: 2}" placeholder='不写就系统默认' v-model="updateForm.seo_keyword"></el-input>
            </el-form-item>
            <el-form-item prop='seo_description' label='SEO描述'>
                <el-input type="textarea" :autosize="{ minRows: 2}" placeholder='不写就系统默认' v-model="updateForm.seo_description"></el-input>
            </el-form-item>
            <el-form-item prop='weigh' label='排序'>
                <el-input v-model="updateForm.weigh" placeholder='请输入排序' clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="medium" @click="handleReset2">重置</el-button>
                <el-button size="medium" type="primary" @click="onSubmitForm">确定</el-button>
            </el-form-item>
        </el-form>
	</div>
</template>

<script>
    import {contentDetail,contentCreate,contentUpdate} from '@/utils/getData';
    import quillEditor from '@/components/quill'

    export default {
        name: "newsEdit",
        components:{
            quillEditor
        },
        data(){
            return{
                id:'',
                updateForm: {
                    column_id:'1',
                    title: "",
                    brief:"",
                    cover:"",
                    content: "",
                    weigh:1
                },
                formItemRules: {
                    language: [{
                        required: true,
                        message: '请选择语言',
                        trigger: 'change'
                    }],
                    title: [{
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur'
                    }],
                    content: [{
                        required: true,
                        message: '请输入内容',
                        trigger: 'blur'
                    }]
                },
            }
        },
        mounted(){
            // 文章id
            this.id = this.$route.params.id;
            if(this.id){//编辑
                this.init();
            }else{
                this.updateForm = {};
                this.$set(this.updateForm,'column_id',1);
                this.$set(this.updateForm,'weigh',1);
            }
        },
        methods:{
            async init(){
                try {
                    let res = await contentDetail(this.id);
                    if (res.code == 0) {
                        this.updateForm = res.data;
                        this.$set(this.updateForm,'content',res.data.content_extend.content);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                } catch(e) {
                    this.$message({
                        showClose:true,
                        message: e.message,
                        type: 'error'
                    });
                }
            },
            onSubmitForm() { //提交表单
                let that = this;
                this.$refs['updateForm'].validate(async (valid) => {
                    try{
                        if (valid) {
                            let formData = that.updateForm;
                            formData.type = "news";
                            let res = {};
                            if (this.id) {
                                // 编辑状态
                                res = await contentUpdate(that.updateForm.id, formData);
                            } else {
                                // 新增状态
                                res = await contentCreate(formData);
                            }
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '保存成功',
                                    type: 'success'
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: 'error'
                                });
                            }
                        }
                    }catch (e) {
                        this.$message({
                            showClose:true,
                            message: e.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleAvatarSuccess(res) {
                this.$set(this.updateForm,'cover',res.data.url);
            },
            handleReset2(){//重置密码表单
                this.$refs["updateForm"].resetFields();
            },
            goBack(){
                this.$router.push('/news');
            }
        }
    }
</script>

<style scoped>
    .d_title{border-bottom:2px solid #999;margin-bottom:30px;position:relative;padding-bottom:10px;}
	.mainCt{padding:10px 20px;}
    .quill-form-item >>>.el-form-item__content{line-height: 1;}

    /* 封面上传 */
    .cover-uploader >>> .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .cover-uploader >>> .el-upload:hover {
        border-color: #409EFF;
    }
    .cover-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 160px;
        height: 160px;
        line-height: 160px;
        text-align: center;
    }
    .cover-img {
        width: 160px;
        height: 160px;
        display: block;
    }
</style>